import { c as _c } from "react/compiler-runtime";
import React from 'react';
export const LightIcon = React.forwardRef<SVGSVGElement>((props, ref) => {
  const $ = _c(7);
  let t0;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M16.5376 17.1136C16.5376 16.0786 17.0761 15.1426 17.8515 14.4571C19.0356 13.4102 19.76 12.1951 19.76 10.2381C19.76 6.13258 16.5718 2.80438 12.6389 2.80438C8.70608 2.80438 5.51788 6.13258 5.51788 10.2381C5.51788 12.0829 6.16163 13.2367 7.22741 14.2486C8.01372 14.9952 8.56562 15.9776 8.56562 17.0619C8.56562 17.4368 8.86952 17.7407 9.24439 17.7407H15.9105C16.2568 17.7407 16.5376 17.4599 16.5376 17.1136Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />;
    t1 = <path d="M12.6741 13.3452L12.6741 17.7407" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />;
    t2 = <path d="M9.82324 10.5295L12.6389 13.3452L15.4546 10.5295" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />;
    t3 = <path d="M9.18311 21.1956H16.0947" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] !== props || $[5] !== ref) {
    t4 = <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props} ref={ref}>{t0}{t1}{t2}{t3}</svg>;
    $[4] = props;
    $[5] = ref;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
});
export default LightIcon;